import { ButtonList } from '@dixa/lib-shared-habla';
import { ampli } from 'lib-shared-tracking';
import { User } from 'lib-shared-types-api';

import { userModalActions } from 'components/usersModal';
import { useAppDispatch } from 'utils/redux/useAppDispatch';

export type MergeContactsActionProps = {
  /** The user that will be used as target user */
  user: User;
  /** Toggle the parent dropdown between open and closed */
  toggleDropdown: () => void;
};

/**
 * Edit contact action
 *
 * A dropdown menu item that opens the edit contact modal.
 */
export const EditContactAction = ({
  user,
  toggleDropdown,
}: MergeContactsActionProps): JSX.Element => {
  const dispatch = useAppDispatch();

  const handleClick = () => {
    dispatch(userModalActions.show({ user }));
    toggleDropdown();
    ampli.contactsCardEditContactClicked();
  };

  return (
    <ButtonList.Item icon="pen" onClick={handleClick}>
      Edit contact
    </ButtonList.Item>
  );
};
